import { GlobalToken } from 'antd/es/theme/interface';
import * as Styled from './ProcessOverview.styled';
import * as ReportingStyled from '../Reporting.styled';

export const getColumns = (token: GlobalToken, data: any[] = []) => {
  const hasValue = (field: string) =>
    data.some(
      (item) =>
        item?.[field] !== null &&
        item?.[field] !== undefined &&
        item?.[field] !== ''
    );

  const organizationalColumns = [
    {
      title: 'Group',
      dataIndex: 'group_name',
      key: 'group_name',
      width: 120
    },
    {
      title: 'Division',
      dataIndex: 'division_name',
      key: 'division_name',
      width: 120
    },
    {
      title: 'Region',
      dataIndex: 'region_name',
      key: 'region_name',
      width: 120
    },
    {
      title: 'Legal Entity',
      dataIndex: 'legal_entity_name',
      key: 'legal_entity_name',
      width: 150
    },
    {
      title: 'Business Unit',
      dataIndex: 'business_unit_name',
      key: 'business_unit_name',
      width: 150
    }
  ].filter((column) => hasValue(column.dataIndex));

  return [
    ...organizationalColumns,
    {
      title: 'Process Title',
      dataIndex: 'business_process_l4_title',
      key: 'business_process_l4_title',
      width: 200
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
      width: 250
    },
    {
      title: 'Process Criticality',
      dataIndex: 'process_criticality_name',
      key: 'process_criticality_name',
      width: 150
    },
    {
      title: 'Risk',
      dataIndex: 'risk_title',
      key: 'risk_title',
      width: 250,
      render: (text: string) =>
        text ? (
          <Styled.EllipsisTag color='orange'>{text}</Styled.EllipsisTag>
        ) : null
    },
    {
      title: 'Control',
      dataIndex: 'control_name',
      key: 'control_name',
      width: 300,
      render: (text: string) =>
        text ? (
          <Styled.EllipsisTag color='blue'>{text}</Styled.EllipsisTag>
        ) : null
    },
    {
      title: 'Control Overall Effectiveness',
      dataIndex: 'control_overall_effectiveness_name',
      key: 'control_overall_effectiveness_name',
      width: 200
    },
    {
      title: 'Process Type',
      dataIndex: 'process_type_name',
      key: 'process_type_name',
      width: 180
    },
    {
      title: 'Owner/Maintainer',
      dataIndex: 'owner_maintainer',
      key: 'owner_maintainer',
      width: 150
    },
    {
      title: 'Responsible Person',
      dataIndex: 'responsible_person',
      key: 'responsible_person',
      width: 150
    },
    {
      title: (
        <ReportingStyled.ReportValidityHeaderWrapper>
          Process Start Date - End Date
        </ReportingStyled.ReportValidityHeaderWrapper>
      ),
      key: 'process_validity',
      onHeaderCell: () => ({
        style: Styled.processOverviewHeaderStyle
      }),
      children: [
        {
          title: () => null,
          dataIndex: 'start_date',
          key: 'start_date',
          width: 120,
          onHeaderCell: () => ({
            style: Styled.processOverviewDateHeaderStyle
          }),
          onCell: () => ({
            style: Styled.processOverviewStartDateCellStyle
          })
        },
        {
          title: () => null,
          dataIndex: 'end_date',
          key: 'end_date',
          width: 120,
          onHeaderCell: () => ({
            style: Styled.processOverviewDateHeaderStyle
          })
        }
      ]
    }
  ];
};
